import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import ListeDiffusion from '../Entity/ListeDiffusion'

/**
* Class ListeDiffusionList
* ListeDiffusionList view component
**/
class ListeDiffusionList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = ListeDiffusion;

    // Filter list
    const filters = [{
      title: "Nom de la liste",
      type: "text",
      name: "libelle",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer les listes de diffusion</h2>
        <GridFilter title="Filtrer les listes de diffusion" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Listes de diffusion" ref={"grid" + objectClass.name} path="listediffusions" objectPath="listediffusions" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + ListeDiffusion.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["grid" + ListeDiffusion.name];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + ListeDiffusion.name];
    grid.clearFilters();
  }

}
export default ListeDiffusionList;



// WEBPACK FOOTER //
// ./src/views/Search/ListeDiffusionList.js